import { useScroll } from 'ahooks';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'umi';
import { useShopCode } from '@/hooks';
import { queryLevelData } from '@/services/api/level';
import NavItem from './NavItem';
import Operate from './Operate';
import styles from './index.less';

const Header = () => {
  const { shopCode } = useShopCode();
  const [categoryData, setCategoryData] = useState<API.categoryItem[]>([]);
  const [navData, setNavData] = useState([]);
  const [searchParams] = useSearchParams();
  const pageType: string = searchParams.get('type') || '';
  const pageId: string = searchParams.get('pageId') || '';
  const { top } = useScroll(document) || {};
  const CATEGORY = 'CATEGORY_COLUMN';
  const INFO = 'INFORMATION_COLUMN';
  const onload = async () => {
    const res: any = await Promise.all([
      queryLevelData(CATEGORY, shopCode, pageType, parseInt(pageId)),
      // queryLevelData(NAV, shopCode, pageType, parseInt(pageId)),
      queryLevelData(INFO, shopCode, pageType, parseInt(pageId)),
    ]);
    if (res && res.length > 0) {
      if (res[0]) {
        const { categoryItemList } = res[0];
        setCategoryData(categoryItemList ?? []);
      }
      if (res[1]) {
        const { itemList } = res[1];
        setNavData(itemList || []);
      }
    }
  };

  useEffect(() => {
    onload();
  }, []);

  // 判断滚动距离是否为0
  const isScrollTopZero = Number(top || 0) === 0;
  const subCategoryTopPosition = isScrollTopZero ? 132 : 50;

  return (
    <header
      className={classnames('relative ', styles.headerBox)}
      style={{ height: `${subCategoryTopPosition}px` }}
    >
      <div
        className={classnames(
          'fixed top-0 left-0 right-0 z-[9] bg-[#fff] w-[100%] shadow-[0px_4px_8px_0px_rgba(0,0,0,0.02)]',
          isScrollTopZero ? 'shadow-[0px 4px 8px 0px rgba(0,0,0,0.02)]' : '',
        )}
      >
        <div
          className={classnames(
            'flex pl-[56px] pr-[56px]',
            isScrollTopZero ? 'flex-col' : 'flex-row',
          )}
        >
          <Link
            to="/"
            className={classnames(
              'flex  items-center justify-center',
              isScrollTopZero ? 'h-[82px]' : 'h-[50px]',
            )}
          >
            <img
              className={classnames(
                'w-[140px] h-[34px]',
                isScrollTopZero ? '' : 'w-[100px] h-[24px]',
              )}
              src="http://file.meilisci.com/1722924680113_BEUKAYlogo%E5%A4%87%E4%BB%BD%402x.png"
            />
          </Link>
          <ul
            className={classnames(
              'ml-[36px] flex items-center justify-center',
              styles.menuTitle,
            )}
          >
            {categoryData?.map((temp) => {
              const {
                categoryId = '',
                name = '',
                subCategoryList = [],
              } = temp || {};
              const list = subCategoryList || [];
              return (
                <NavItem
                  name={name}
                  key={categoryId}
                  url={`/category?kname=${name}&k=`}
                  subCategoryList={list}
                  categoryId={categoryId}
                  isScrollTopZero={isScrollTopZero}
                  subCategoryTopPosition={subCategoryTopPosition}
                />
              );
            })}
            {navData?.map((temp) => {
              const { id, name, children = [] } = temp || {};
              const subCategoryList =
                children?.map((info: any) => ({
                  // @ts-ignore
                  ...info,
                  image: info?.name
                    ? `https://file.meilisci.com/resource/packaging-mall-web/${info.name}.png`
                    : '',
                })) || [];
              return (
                <NavItem
                  key={id}
                  name={name}
                  categoryId={id}
                  url="/info/list/"
                  isScrollTopZero={isScrollTopZero}
                  subCategoryList={subCategoryList}
                  subCategoryTopPosition={subCategoryTopPosition}
                />
              );
            })}
          </ul>
        </div>
        <Operate />
      </div>
    </header>
  );
};

export default Header;
